module.exports = __webpack_public_path__ + "img/rejected.ff0a52cf.svg";